import FieldUser from "../../../../fields3/generic/user/user";
import FieldConfig from "../../../proto/field-config";
import UserManager from "../../../../manager/user-manager/user-manager";

export default class FieldTimeReportUser extends FieldUser {

    constructor(config:FieldConfig) {
        super(config);

        this.label              = "Reported by user"
        this.description        = "Choose the user for whom this report will be submitted. Manager access is required to submit on behalf of another user."
        this.noValueOption      = false
    }

    // access(model:any): 'read' | 'write' | false {
    //
    //     if (_.has(model,'systemStatus')) {
    //         if (!gd.const.systemStatus.isOpen(model.systemStatus)) return 'read'
    //     }
    //
    //     if (_.has(model,'projectId')) {
    //         // ARE you sure about it ? seems like not a good deal - check canChangeAr - this is task model
    //         if (!gd.ac.check.project.fullAccess(model.projectId)) return 'read'
    //     }
    //
    //     return 'write'
    // }

    getOptionsForEdit(model:any) {

        const userManager = new UserManager()
        const managerIds = userManager.getManagerForUsersIds();

        return _.map(managerIds, (userId:ID)=>{

            const user = gd.session.users.get(userId)!

            return {
                value: user.id,
                label: user.name
            }
        })

    }

}
